import { useState, useEffect } from 'react';
import { apiService } from '../services/apiService';

export const useModalData = (
  isOpen: boolean,
  showLotTechnique: boolean = true,
  showLotGeographique: boolean = true,
  showDepartement: boolean = false
) => {
  const [lotsTechniques, setLotsTechniques] = useState([]);
  const [lotsGeographiques, setLotsGeographiques] = useState([]);
  const [departements, setDepartements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isOpen) return;

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const promises = [];

        if (showLotTechnique) {
          promises.push(apiService.getLotsTechniques().then(setLotsTechniques));
        }

        if (showLotGeographique) {
          promises.push(apiService.getLotsGeographiques().then(setLotsGeographiques));
        }

        if (showDepartement) {
          promises.push(apiService.getDepartements().then(setDepartements));
        }

        await Promise.all(promises);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erreur lors du chargement des données');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [isOpen, showLotTechnique, showLotGeographique, showDepartement]);

  return {
    lotsTechniques,
    lotsGeographiques,
    departements,
    loading,
    error
  };
};